import * as lexActionType from '../actionsType/lexGenCopyLink.actionType';

export const initialState = {
    response: null,
    exception: null
};

export function lexGenCopyLinkReducer(state = initialState, action) {
    switch (action.type) {
        case lexActionType.LEX_GENERATELINK_SUCCESS:
            return {...state, response: action.payload};
        case lexActionType.LEX_GENERATELINK_ERROR:
            return {...state, exception: lexActionType.LEX_GENERATELINK_ERROR};
        default:
            return state;
    }
}
